module.exports = __webpack_public_path__ + "img/logo-feelgood-colored-linebreak.aed52b1c.png";